import './i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@betstarters/auth'
import App from './App'
import api from './api/client'
import './index.css'

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider config={{ api }}>
        <App />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
